export default __webpack_public_path__ + "static/media/bookory.e6ecf628.webp";